var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activityDetails"},[_c('div',{staticClass:"details",domProps:{"innerHTML":_vm._s(_vm.longtext)}}),_c('div',{staticClass:"share"})])}
var staticRenderFns = []

export { render, staticRenderFns }